import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-darker px-6 pt-20 pb-16 md:pt-32 md:pb-24" data-id="element-51">
      {/* Background subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-gold/10 blur-[120px] rounded-full pointer-events-none" data-id="element-52"></div>

      <div className="mx-auto max-w-6xl relative z-10" data-id="element-53">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col gap-6 text-center lg:text-left" data-id="element-55">
            <div className="inline-block mx-auto lg:mx-0 rounded-full bg-brand-gold/10 px-4 py-1.5 border border-brand-gold/20" data-id="element-56">
              <span className="text-brand-gold font-semibold text-sm tracking-wide uppercase" data-id="element-57">
                Solo para networkers
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.1] text-white" data-id="element-58">
              Plan de 7 Días para Traer{' '}
              <span className="text-brand-gold" data-id="element-59">Prospectos Calificados</span>{' '}
              Todos los Días con las Redes Sociales
            </h1>

            <p className="text-base md:text-lg font-medium text-slate-400" data-id="element-60">
              (Sin Perseguir a tu Familia ni Parecer un Vendedor Desesperado)
            </p>

            <p className="text-lg text-slate-400 leading-relaxed mt-2" data-id="element-61">
              Deja de perseguir conocidos que no tienen interés. Activa el
              Sistema Magnético que convierte tu perfil en un filtro automático
              de prospectos, incluso si hoy tienes menos de 500 seguidores.
            </p>

            {/* Mobile-only product image — shown before CTA on small screens */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="block lg:hidden mx-auto w-full max-w-xs" data-id="element-62">
              <div className="relative aspect-[4/5] w-full" data-id="element-63">
                <img src="https://cdn.magicpatterns.com/uploads/x7PePMgMreZkAWBkqgaZhg/mockup_libro.png" alt="Networker Magnético - Plan de 7 Días" className="object-contain w-full h-full drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-64" />
              </div>
            </motion.div>

            <div className="mt-4 flex flex-col items-center lg:items-start gap-4" data-id="element-65">
              <CTAButton data-id="element-66" />
              <p className="text-sm text-slate-500 flex items-center gap-2" data-id="element-67">
                <span className="flex h-2 w-2 rounded-full bg-green-500" data-id="element-68"></span>
                Acceso inmediato y seguro
              </p>
            </div>
          </motion.div>

          {/* Desktop-only product image — right column */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="hidden lg:block relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-69">
            <div className="relative aspect-[4/5] w-full" data-id="element-70">
              <img src="https://cdn.magicpatterns.com/uploads/x7PePMgMreZkAWBkqgaZhg/mockup_libro.png" alt="Networker Magnético - Plan de 7 Días" className="object-contain w-full h-full drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-71" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}